import { useContext } from "react";
import { useIntl } from "react-intl";

import { PublicationRead } from "@nens/rana/api-v1";
import { FormErrors } from "@nens/ranalib";

import { ProjectContext } from "@/stores/project-provider";

import { useCreatePublication } from "../../../api/create";
import { PublicationFormValues } from "../create";

export function usePublicationCreate({
  onSuccess,
}: {
  onSuccess: (data: PublicationRead) => void;
}) {
  const intl = useIntl();
  const { id: projectId } = useContext(ProjectContext);

  const { isMutating, mutate } = useCreatePublication();

  const validate = (values: PublicationFormValues) => {
    const errors: FormErrors = {};
    if (!values.name) {
      errors.name = intl.formatMessage({
        id: "form.required.name",
        defaultMessage: "Name is required",
      });
    }

    return errors;
  };

  // Submit can assume validate returned no errors.
  const submit = (values: PublicationFormValues, setErrors: (errors: FormErrors) => void) => {
    const name: string = values.name + "";
    const description: string = (values.description ?? "") + "";

    const publicaton = {
      projectId,
      name,
      description,
    };

    mutate(publicaton, {
      onError: (errors) => {
        if (errors) setErrors(errors);
      },
      onSuccess,
    });
  };

  return { validate, submit, isMutating };
}
